/**
 * Optional Meta Pixel & Google Analytics loaders.
 *
 * Only initialise when the backend /woningwaarde/config returns a real ID.
 * All tracking is opt-in through the existing cookie-consent (handled
 * elsewhere); we do NOT send email/address PII as event parameters.
 */

let pixelLoaded = false;
let gaLoaded = false;

export const loadMetaPixel = (pixelId) => {
  if (!pixelId || pixelLoaded || typeof window === "undefined") return;
  pixelLoaded = true;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
};

export const trackPixel = (eventName, params = {}) => {
  if (!pixelLoaded || !window.fbq) return;
  window.fbq("track", eventName, params);
};

export const loadGA = (measurementId) => {
  if (!measurementId || gaLoaded || typeof window === "undefined") return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { anonymize_ip: true });
};

export const trackGA = (eventName, params = {}) => {
  if (!gaLoaded || !window.gtag) return;
  window.gtag("event", eventName, params);
};

/** Fire a conversion to BOTH providers if active. Never pass PII. */
export const trackConversion = (name, params = {}) => {
  trackPixel(name, params);
  trackGA(name, params);
};
